<template>
  <div class="base-container">
    <div class="base-body">
      <slot name="content"></slot>
    </div>
    <div class="base-footer">
      <DygcFooter class="mt-2 -mb-2" />
    </div>
  </div>
</template>
<script>
import DygcFooter from 'components/dygc-footer-bottom/index'
export default {
  
  components: { DygcFooter }
}
</script>
<style lang="scss" scoped>
  .base-container{
    height: 100%;
    padding: 16px 16px 0;
    box-sizing: border-box;
    .base-body{
      height: calc(100% - 40px);
    }
  }
</style>